export default {
  id: 'ClassOnePage',
  code: 'CN',
  text: {
    'Search Private Class': '搜索私课名称',
    "We have upgraded our class functionality, please set class tuition fee to facilitate the statistics of tuition consumption": '我们对班级功能进行了升级，请设置班级学费标准以方便进行学费消耗统计。',
    'Sort by': '排序',
    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
    'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
    'Name: A-Z': '按名称：由A到Z',
    'Name: Z-A': '按名称：由Z到A',

    'Current': '当期私课',
    'Closed': '已关闭私课',
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/ClassOne/locale.js